var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      staticStyle: {
        height: "100%",
        overflow: "auto",
        "padding-bottom": "53px",
      },
      attrs: {
        title: _vm.title,
        maskClosable: true,
        width: _vm.drawerWidth,
        placement: "right",
        closable: true,
        visible: _vm.visible,
      },
      on: { close: _vm.handleCancel },
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticStyle: { width: "100%" } }, [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "span",
            {
              staticStyle: {
                display: "inline-block",
                width: "calc(100% - 51px)",
                "padding-right": "10px",
                "text-align": "right",
              },
            },
            [
              _c("a-button", {
                staticStyle: { height: "20px", width: "20px", border: "0px" },
                attrs: { icon: "appstore" },
                on: { click: _vm.toggleScreen },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "用户账号",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator.trim",
                        value: ["username", _vm.validatorRules.username],
                        expression: "['username', validatorRules.username]",
                        modifiers: { trim: true },
                      },
                    ],
                    attrs: {
                      placeholder: "请输入用户账号",
                      readOnly: !!_vm.model.id,
                    },
                  }),
                ],
                1
              ),
              !_vm.model.id
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "登录密码",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                        },
                      },
                      [
                        _c("a-input-password", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["password"],
                              expression: "['password']",
                            },
                          ],
                          attrs: { placeholder: "请输入登录密码" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "确认密码",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                        },
                      },
                      [
                        _c("a-input-password", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "confirmpassword",
                                _vm.validatorRules.confirmpassword,
                              ],
                              expression:
                                "['confirmpassword', validatorRules.confirmpassword]",
                            },
                          ],
                          attrs: { placeholder: "请重新输入登录密码" },
                          on: { blur: _vm.handleConfirmBlur },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "用户姓名",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator.trim",
                        value: ["realname", _vm.validatorRules.realname],
                        expression: "['realname', validatorRules.realname]",
                        modifiers: { trim: true },
                      },
                    ],
                    attrs: { placeholder: "请输入用户姓名" },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.departDisabled,
                      expression: "!departDisabled",
                    },
                  ],
                  attrs: {
                    label: "租户分配",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "multiple",
                        placeholder: "请选择租户分配",
                        disabled: _vm.disableSubmit,
                      },
                      model: {
                        value: _vm.currentTenant,
                        callback: function ($$v) {
                          _vm.currentTenant = $$v
                        },
                        expression: "currentTenant",
                      },
                    },
                    _vm._l(_vm.tenantList, function (item, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: item.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "身份",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "multiple",
                        placeholder: "请选择身份",
                        disabled: _vm.disableSubmit,
                      },
                      model: {
                        value: _vm.currentUserIdentity,
                        callback: function ($$v) {
                          _vm.currentUserIdentity = $$v
                        },
                        expression: "currentUserIdentity",
                      },
                    },
                    _vm._l(_vm.userIdentityList, function (item, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: item.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.text) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "手机号码",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["phone", _vm.validatorRules.phone],
                        expression: "['phone', validatorRules.phone]",
                      },
                    ],
                    attrs: { placeholder: "请输入手机号码" },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "第三方用户类型",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      placeholder: "请输入第三方用户类型",
                      dictCode: "thirdType",
                    },
                    model: {
                      value: _vm.model.thirdType,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "thirdType", $$v)
                      },
                      expression: "model.thirdType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "第三方用户ID",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["thirdId"],
                        expression: "['thirdId']",
                      },
                    ],
                    attrs: { placeholder: "请输入第三方用户ID" },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("depart-window", { ref: "departWindow", on: { ok: _vm.modalFormOk } }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disableSubmit,
              expression: "!disableSubmit",
            },
          ],
          staticClass: "drawer-bootom-button",
        },
        [
          _c(
            "a-popconfirm",
            {
              attrs: {
                title: "确定放弃编辑？",
                okText: "确定",
                cancelText: "取消",
              },
              on: { confirm: _vm.handleCancel },
            },
            [
              _c("a-button", { staticStyle: { "margin-right": "0.8rem" } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }